import {app} from '../../app';
import IScope = angular.IScope;
import {ISessionService} from "../../services/SessionService";
import IComponentController = angular.IComponentController;

export class CheckboxQuestionPreviewComponent {

    protected sessionService:ISessionService;

    public nextQuestionCallback;
    public question:IQuestion;
    public value:boolean;

    static $inject = ['SessionService'];

    constructor(sessionService:ISessionService) {
        this.sessionService = sessionService;
    }

    $onInit() {
        this.value = false;

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            this.value = answer.values[0].value;
        }
    }

}

app.component('checkboxQuestionPreview', {
    templateUrl: 'templates/components/questionPreviews/checkboxQuestionPreview.html',
    controller: CheckboxQuestionPreviewComponent,
    controllerAs: 'checkboxQuestionPreview',
    bindings: {
        question: '<'
    }
});